export const isSmallScreen = window.screen.width < 700;
